import {Api,handleResponse,handleError} from '../../../../../../api';
//Action
const Actions = {
    GetOffer: 'external/get-offer',
    GetOfferFiles: 'external/get-offer-files',
    GetBestOffer: 'external/get-best-offer',
    GetFiles: 'external/get-tender-files',
    DownloadFile:'external/download-tender-file',
    DownloadAllFiles:'external/download-all-tender-files',
    NoticeTenderChanges:'external/tender-changes/notice',
    NoticeOfferChanges:'external/offer-changes/notice',

}


export const apiRequest = {
    getOffer,
    getOfferFiles,
    getBestOffer,
    getFiles,
    downloadFile,
    downloadAllFile,
    noticeTenderChanges,
    noticeOfferChanges
};

async function getOffer(parent,tenderId) {
    await new Api().call.get(`${Actions.GetOffer}/${tenderId}`).then(handleResponse)
        .then(res => {
            parent.setState((prevState)=>({
                offer:res,
                loading:{
                    ...prevState.loading,
                    offer:false
                }
            }));
        }).catch(handleError);
}


async function noticeTenderChanges(parent,model) {
    const {onSelect} = parent.props;
    await new Api().call.post(`${Actions.NoticeTenderChanges}/${model.id}`).then(handleResponse)
        .then(res => {
            parent.setState({
                notice:false
            });         
            onSelect(res.data);
        }).catch(error=>{
            handleError(error);

            parent.setState({
                notice:false
            });
        });
}

async function noticeOfferChanges(parent,model) {
    const {onSelect} = parent.props;
    await new Api().call.post(`${Actions.NoticeOfferChanges}/${model.id}`).then(handleResponse)
        .then(res => {
            parent.setState({
                notice:false
            });         
            onSelect(res.data);
        }).catch(error=>{
            handleError(error);

            parent.setState({
                notice:false
            });
        });
}

async function getOfferFiles(parent,tenderId) {
    await new Api().call.get(`${Actions.GetOfferFiles}/${tenderId}`).then(handleResponse)
        .then(res => {
            parent.setState((prevState)=>({
                offerFiles:res
            }));
        }).catch(handleError);
}


async function getBestOffer(parent,tenderId) {
    await new Api().call.get(`${Actions.GetBestOffer}/${tenderId}`).then(handleResponse)
        .then(res => {
            parent.setState((prevState)=>({
                bestOffer:res,
                loading:{
                    ...prevState.loading,
                    bestOffer:false
                }
            }));
        }).catch(handleError);
}

async function getFiles(parent,model) {
    await new Api().call.post(Actions.GetFiles,model).then(handleResponse)
        .then(res => {
            parent.setState((prevState)=>({
                items:res,
                loading:{
                    ...prevState.loading,
                    items:false
                }
            }));
        }).catch(handleError);
}

async function downloadFile(parent,tenderId,fileId,isFolder) {

    parent.setState({
        downloadIsProgress:fileId
    });
        await new Api().call.post(`${Actions.DownloadFile}/${tenderId}/${fileId}/${isFolder}`,null,{
            onDownloadProgress: progressEvent => {
                const {loaded,total} = progressEvent;
            
                let percent = Math.floor(loaded / total * 100)
            //console.log(`${loaded}kb of ${total}kb | ${percent}%`);
            },
            responseType: 'arraybuffer'
        })
        .then(res => {
            var blob = new Blob([res.data], {type: "application/octet-stream"});
            var header = res.headers['content-disposition'];
            //Get file name from header
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(header);
            let fileName;
            if (matches != null && matches[1]) { 
                fileName = matches[1].replace(/['"]/g, '');
            }
             //Create the download link
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            parent.setState({
                    downloadIsProgress:null
            });
            
        }).catch(error=>{
            handleError(error);
            let response = {message:'Váratlan hiba miatt nem tölthető le',type:'error'}
            if(error.response!==null && error.response!==undefined && error.response.data!==null && error.response.data!==undefined){
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
                var obj = JSON.parse(decode_utf8(decodedString));
                if(obj!==null && obj!==undefined){
                    response = obj;
                }
            }
            parent.setState({
                     downloadIsProgress:null,
                     requestResponse: response
             });
        });
    
}

async function downloadAllFile(parent,tenderId,parentId) {


    parent.setState({
        zipIsProgress:true
    });

    await new Api().call.post(`${Actions.DownloadAllFiles}/${tenderId}/${parentId}`,null,{
        onDownloadProgress: progressEvent => {
            const {loaded,total} = progressEvent;
        
            let percent = Math.floor(loaded / total * 100)
        //console.log(`${loaded}kb of ${total}kb | ${percent}%`);
        },
        responseType: 'arraybuffer'

    }).then(res => {       
            var blob = new Blob([res.data], {type: "application/octet-stream"});
            var header = res.headers['content-disposition'];
            //Get file name from header
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(header);
            let fileName;
            if (matches != null && matches[1]) { 
                  fileName = matches[1].replace(/['"]/g, '');
            }
            //Create the download link
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            parent.setState({
                zipIsProgress:false
            });

        }).catch(error=>{
            handleError(error);
            let response = {message:'Váratlan hiba miatt nem tölthető le',type:'error'}
            if(error.response!==null && error.response!==undefined && error.response.data!==null && error.response.data!==undefined){
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
                var obj = JSON.parse(decode_utf8(decodedString));
                if(obj!==null && obj!==undefined){
                    response = obj;
                }
            }
            parent.setState({
                     requestResponse: response,
                     zipIsProgress:false
             });
        });
    
}

function decode_utf8(utftext) {
    var plaintext = ""; var i=0; 
    var c=0;
    var c1=0;
    var c2=0;
    var c3=0;
    // while-Schleife, weil einige Zeichen uebersprungen werden
    while(i<utftext.length)
        {
        c = utftext.charCodeAt(i);
        if (c<128) {
            plaintext += String.fromCharCode(c);
            i++;}
        else if((c>191) && (c<224)) {
            c2 = utftext.charCodeAt(i+1);
            plaintext += String.fromCharCode(((c&31)<<6) | (c2&63));
            i+=2;}
        else {
            c2 = utftext.charCodeAt(i+1); c3 = utftext.charCodeAt(i+2);
            plaintext += String.fromCharCode(((c&15)<<12) | ((c2&63)<<6) | (c3&63));
            i+=3;}
        }
    return plaintext;
}	
